import { TranslatePipe } from './translate.pipe';
import { TRANSLATION_PROVIDERS } from './translations';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [],
    exports: [TranslatePipe],
    declarations: [TranslatePipe],
    providers : [TRANSLATION_PROVIDERS]
})
export class TranslateModule { }
